import React from 'react'

const Pause2 = () => {
  return (
    <svg
                          width="44"
                          height="44"
                          viewBox="0 0 44 44"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g>
                            <rect
                              x="2"
                              y="1"
                              width="40"
                              height="40"
                              rx="16"
                              fill="#F9BB00"
                            />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M16.75 14.25C16.75 13.8358 17.0858 13.5 17.5 13.5H19C19.4142 13.5 19.75 13.8358 19.75 14.25V27.75C19.75 28.1642 19.4142 28.5 19 28.5H17.5C17.3011 28.5 17.1103 28.421 16.9697 28.2803C16.829 28.1397 16.75 27.9489 16.75 27.75L16.75 14.25ZM24.25 14.25C24.25 13.8358 24.5858 13.5 25 13.5H26.5C26.6989 13.5 26.8897 13.579 27.0303 13.7197C27.171 13.8603 27.25 14.0511 27.25 14.25V27.75C27.25 28.1642 26.9142 28.5 26.5 28.5H25C24.5858 28.5 24.25 28.1642 24.25 27.75V14.25Z"
                              fill="white"
                            />
                          </g>
                          <defs>
                            <filter
                              id="filter0_dd_411_28846"
                              x="0"
                              y="0"
                              width="44"
                              height="44"
                              filterUnits="userSpaceOnUse"
                              colorInterpolationFilters="sRGB"
                            >
                              <feFlood
                                floodOpacity="0"
                                result="BackgroundImageFix"
                              />
                              <feColorMatrix
                                in="SourceAlpha"
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                result="hardAlpha"
                              />
                              <feOffset dy="1" />
                              <feGaussianBlur stdDeviation="1" />
                              <feColorMatrix
                                type="matrix"
                                values="0 0 0 0 0.356863 0 0 0 0 0.407843 0 0 0 0 0.443137 0 0 0 0.32 0"
                              />
                              <feBlend
                                mode="normal"
                                in2="BackgroundImageFix"
                                result="effect1_dropShadow_411_28846"
                              />
                              <feColorMatrix
                                in="SourceAlpha"
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                result="hardAlpha"
                              />
                              <feOffset />
                              <feGaussianBlur stdDeviation="0.5" />
                              <feColorMatrix
                                type="matrix"
                                values="0 0 0 0 0.101961 0 0 0 0 0.12549 0 0 0 0 0.141176 0 0 0 0.32 0"
                              />
                              <feBlend
                                mode="normal"
                                in2="effect1_dropShadow_411_28846"
                                result="effect2_dropShadow_411_28846"
                              />
                              <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect2_dropShadow_411_28846"
                                result="shape"
                              />
                            </filter>
                          </defs>
                        </svg>
  )
}

export default Pause2